import { render, staticRenderFns } from "./manuscript-versions.dialog.vue?vue&type=template&id=393a1e41&scoped=true"
import script from "./manuscript-versions.dialog.vue?vue&type=script&lang=js"
export * from "./manuscript-versions.dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393a1e41",
  null
  
)

export default component.exports